import { createSelector } from 'reselect';
import { TDOId } from '@common-modules/universal/models/Brands';
import { defaultJobSlice, namespace, JobStore } from './store';

export const selectStore = (state: { [namespace]: JobStore }) =>
  state[namespace];

export const selectAllEngineStatuses = (tdoId: TDOId) =>
  createSelector(selectStore, (s) => s[tdoId] || {});

export const selectEngineStatus = (tdoId: TDOId, jobId: string) =>
  createSelector(
    selectAllEngineStatuses(tdoId),
    (s) => s[jobId] || defaultJobSlice()
  );
